import React, {useEffect, useState} from "react";
import BellTable from "./BellTable";
import {saveBell, searchBell} from "./services";
import {searchBellQueue} from "../../../../common-services";
import BellScheduler from "../../../../Scheduler/BellScheduler";
import {setBellInfo} from "../../../../utils/BellStorageUtils";


const mapToDTO = (list) => {
    return list.map((bell) => {
        const {name, time, music, type, status, playTime, musicId} = bell;

        // Extract hourTime and file details
        const hourTime = time; // Use the time directly as hourTime
        // const fileType = music ? music?.type : null;
        const fileUrl = music ? music : null;
        const enabled = status;

        return {
            name,
            hourTime,
            type,
            enabled,
            // fileType,
            fileUrl,
            // Id of the chosen bell-music option, so the backend can link the bell
            // to its music record (not just the resolved file URL).
            bellMusicId: musicId ?? null,
            playTime: playTime ? parseInt(playTime, 10) : null,
        };
    });
}

function Bell(props) {

    const {activeRoster} = props
    const [bellList, setBellList] = useState([])
    const [bellLoading, setBellLoading] = useState(true)

    useEffect(() => {
        fetchBellList()
    }, []);

    const updateLocalStorage = async () => {
        console.log("updating process started")
        try {
            const response = await searchBellQueue()
            if (response) {
                // force: re-cache audio even at an unchanged URL (bell replaced).
                setBellInfo(response.data, {force: true});
            }
        } catch (e) {
            console.error("Error while updating local storage e:", e);
        }

    }

    const handleBellUpload = async (data) => {
        console.log("data::", data)
        try {

            const dtoList = mapToDTO(data);
            let requestDto = {
                rosterId: activeRoster.id,
                bellList: dtoList
            };
            const response = await saveBell(requestDto)

            if (response.status === 201) {
                await updateLocalStorage();
                await fetchBellList();
            }
        } catch (e) {
            console.log(e)
        }

    }

    const fetchBellList = async () => {
        setBellLoading(true)
        try {
            let requestDTO = {
                id: activeRoster.id,
                number: "",
                code: ""
            }
            const response = await searchBell(requestDTO)
            console.log("respinse", response)
            if (response.status === 200) {
                setBellList(response.data);
            }
        } catch (e) {
            console.error("Error while fetchBellList :{}", e)
        } finally {
            setBellLoading(false)
        }
    }
    return (
        <>
            <BellScheduler/>
            <BellTable
                title={"घन्टिहरु"}
                captions={["नाम", "समय स्थिति","समय स्थिति", "घण्टी", "पंक्ति", "स्थिति", "क्रियाकलाप"]}
                bellList={bellList}
                isLoading={bellLoading}
                handleBellUpload={handleBellUpload}
                fetchBellList={fetchBellList}
            />
        </>
    );
}

export default Bell;
